import api from './api'

export const emailSuppressionService = {
  getAllSuppressions: async () => {
    const response = await api.get('/email-suppression')
    return response.data
  },

  createSuppression: async (data) => {
    const response = await api.post('/email-suppression', data)
    return response.data
  },

  deleteSuppression: async (id) => {
    const response = await api.delete(`/email-suppression/${id}`)
    return response.data
  }
}
